import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class CreditLimitService {
    /**
     * Get authentication token from localStorage
     */
    getAuthToken() {
        const token = localStorage.getItem('adminToken');
        return token ? `Bearer ${token}` : '';
    }

    /**
     * Get all users with their credit information
     */
    async getAllUsersWithCredit(params = {}) {
        try {
            const queryParams = new URLSearchParams();

            if (params.page) queryParams.append('page', params.page);
            if (params.limit) queryParams.append('limit', params.limit);
            if (params.search) queryParams.append('search', params.search);

            const response = await axios.get(`${API_URL}/credit-limit/users?${queryParams.toString()}`, {
                headers: {
                    'Authorization': this.getAuthToken()
                }
            });

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Set user's credit limit and tenure
     */
    async setCreditLimitAndTenure(userId, data) {
        try {
            const response = await axios.put(`${API_URL}/credit-limit/users/${userId}`, data, {
                headers: {
                    'Authorization': this.getAuthToken(),
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get user's credit transactions
     */
    async getUserCreditTransactions(userId, params = {}) {
        try {
            const queryParams = new URLSearchParams();

            if (params.page) queryParams.append('page', params.page);
            if (params.limit) queryParams.append('limit', params.limit);

            const response = await axios.get(`${API_URL}/credit-limit/transactions/${userId}?${queryParams.toString()}`, {
                headers: {
                    'Authorization': this.getAuthToken()
                }
            });

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get credit limit statistics
     */
    async getCreditStats() {
        try {
            const response = await axios.get(`${API_URL}/credit-limit/stats`, {
                headers: {
                    'Authorization': this.getAuthToken()
                }
            });

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Check credit availability for user
     */
    async checkCreditAvailability(userId, amount = null) {
        try {
            const queryParams = new URLSearchParams();
            if (amount) queryParams.append('amount', amount);

            const response = await axios.get(`${API_URL}/credit-limit/check/${userId}?${queryParams.toString()}`, {
                headers: {
                    'Authorization': this.getAuthToken()
                }
            });

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Handle API errors
     */
    handleError(error) {
        if (error.response) {
            return {
                message: error.response.data.message || 'An error occurred',
                errors: error.response.data.errors || [],
                status: error.response.status
            };
        }
        return {
            message: 'Network error. Please check your connection.',
            errors: [],
            status: 0
        };
    }
}

export default new CreditLimitService();